module.exports = {"532322101":"妥甸镇","532322102":"大庄镇","532322103":"法脿镇","532322104":"鄂嘉镇","532322105":"大麦地镇","532322201":"安龙堡乡","532322202":"爱尼山乡","532322203":"独田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532322.json
// module id = 2615
// module chunks = 0